"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        var CompanyChooser = /** @class */ (function (_super) {
            __extends(CompanyChooser, _super);
            function CompanyChooser(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                $.when($dyn.deferred.onHasValue($dyn.user)).done(function (user) {
                    // Once the user is available then observe the changes to the navigation company.
                    $dyn.observe(user.Company, function () {
                        if (_this.PartForm) {
                            $dyn.applyFunction(_this.PartForm.Refresh, _this.PartForm);
                        }
                    });
                });
                return _this;
            }
            return CompanyChooser;
        }($dyn.controls.Part));
        controls.CompanyChooser = CompanyChooser;
        CompanyChooser.prototype.template = "Part";
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=CompanyChooser.js.map
